import { getElement, getElements, styleToNumber } from '../utils/functional'
import $ from 'jquery'

export default class drawerCategories {
  constructor (el) {
    this.els = {
      el,
      toggle: getElements('.drw-NavCat_ItemToggle'),
      toggleSub: getElements('.drw-NavCat_SubItemToggle')
    }

    function getElHeight (el) {
      el.style.display = 'block'
      const style = getComputedStyle(el)
      const height =
        el.offsetHeight +
        styleToNumber(style.marginTop) +
        styleToNumber(style.marginBottom)
      el.style.display = ''
      return height
    }

    this.els.toggle.forEach(target => {
      target.addEventListener('click', _ => {
        target.classList.toggle('drw-NavCat_ItemToggle-active')
        const targetUl = getElement('.drw-NavCat_SubItems', {
          context: target.parentNode
        })
        $(targetUl).slideToggle()
      })
    })

    this.els.toggleSub.forEach(target => {
      target.addEventListener('click', _ => {
        target.classList.toggle('drw-NavCat_ItemToggle-active')
        const targetUl = getElement('.drw-NavCat_SubSubItems', {
          context: target.parentNode
        })
        $(targetUl).slideToggle()
      })
    })
  }
}
